import { render } from "./blacklistIps.vue?vue&type=template&id=950a92e0"
import script from "./blacklistIps.vue?vue&type=script&lang=js"
export * from "./blacklistIps.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__